<template>
  <main-content-layout title="증명서" img-src="certificates_collection_icon.png">
    <template v-slot:content>
      <v-row
        class="certificate-collection-layout"
        align="stretch"
        dense
        justify="start"
      >
        <v-col
          cols="6"
          v-for="(item, index) in certificateTitleList"
          :key="index"
        >
          <v-card class="certificate-collection-content" rounded="lg" @click="routerCertificate">
            <div class="certificate-header">
              <span><strong>{{ item.name }}</strong></span>
              <span>{{ item.subName }}</span>
            </div>
            <div class="certificate-bottom">
              <v-img class="router-icon" :src="require(`@/assets/images/icons/page_router_icon.png`)" />
            </div>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </main-content-layout>
</template>

<script>

import MainContentLayout from "@/pages/Main/components/layout/MainContentLayout.vue";
import router from "@/router";

export default {
  name: "CertificatesCollection",
  components: {MainContentLayout},
  data() {
    return {
      certificateTitleList: [
        { name: "위촉증명서"},
        { name: "경력증명서"},
        { name: "소득자료증명서", subName: "(전년도)"},
        { name: "소득자료증명서", subName: "(전전년도)"}
      ]
    }
  },
  methods: {
    routerCertificate() {
      router.push({name: "Certificate"});
    }
  }
}
</script>

<style lang="scss" scoped>
.certificate-collection-layout {
  width: 100%;
  height: 100%;
  .certificate-collection-content {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 16px;
    height: 100%;
    //min-height: 10vh;
    max-height: 200px;
    .certificate-header {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      font-size: min(3.5vw, 20px);
      text-wrap: nowrap;
    }
    .certificate-bottom {
      position: absolute;
      right: 10px;
      bottom: 10px;
      .router-icon {
        box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
        border-radius: 40px;
      }
    }
  }
}
</style>